import styled from 'styled-components'
import { colors, sizes } from '../../util'

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 88rem;
  width: 100%;
  display: none;
  @media (min-width: ${sizes.smallmedium}) {
    display: block;
  }
`

export const Inside = styled.a`
  display: block;
  text-align: center;
  margin: 0 1.5rem;
  padding: 1rem 0;
  border-bottom: 1px solid ${colors.grey};
  color: ${props => props.theme.color};

  @media (min-width: ${sizes.medium}) {
    margin: 0 3.5rem;
  }
`



// WEBPACK FOOTER //
// ./src/components/Warning/styles.js